<template>
  <div class="rt-collapse">
    <div class="rt-collapse-header" @click="collapseClick">
      <rt-icon
        :name="showContent ? 'rt-base-angle_up' : 'rt-base-angle_down'"
        size="18"
        color="#143E81"
      />
      <p>{{ title }}</p>
    </div>
    <div class="rt-collapse-content">
      <rt-collapse-transition>
        <template v-show="showContent">
          <slot />
        </template>
      </rt-collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RtCollapse',
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showContent: this.show
    };
  },
  methods: {
    collapseClick(val) {
      this.showContent = !this.showContent;
    }
  }
};
</script>

<style lang="less">
.rt-collapse {
  .el-collapse {
    .el-collapse-item__header {
      .rt-collapse-item-title {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtCollapse.vue?06059d5b